const STAGES = [
  { x: 80, label: "Early Development", tags: ["TPP stress-test", "Evidence gaps"] },
  { x: 240, label: "Pre-Launch", tags: ["SLR · NMA · Models", "JCA / HTA readiness"] },
  { x: 400, label: "Launch & Access", tags: ["Dossiers · AMCP", "IRA · MFN"] },
  { x: 560, label: "In-Market", tags: ["RWE studies", "HCP · Patient voice"] },
  { x: 720, label: "Lifecycle & Portfolio", tags: ["Expansion · LOE", "BD due diligence"] },
];
const Y = 300;
const YS = [300, 190, 410, 190, 300];
const path = "M 80 300 C 160 300, 160 190, 240 190 S 320 410, 400 410 S 480 190, 560 190 S 640 300, 720 300";

export function HeroGraphic() {
  return (
    <div data-testid="hero-graphic" className="relative w-full">
      <svg viewBox="0 0 800 560" className="hidden h-auto w-full md:block" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="hg-line" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stopColor="#5eead4" stopOpacity="0.3" /><stop offset="0.5" stopColor="#5eead4" /><stop offset="1" stopColor="#5eead4" stopOpacity="0.3" /></linearGradient>
          <radialGradient id="hg-glow"><stop offset="0" stopColor="#0078a1" stopOpacity="0.7" /><stop offset="1" stopColor="#0078a1" stopOpacity="0" /></radialGradient>
        </defs>
        <ellipse cx="400" cy="300" rx="390" ry="190" fill="url(#hg-glow)" />
        <line x1="20" y1={Y} x2="780" y2={Y} stroke="rgba(255,255,255,0.08)" strokeDasharray="3 6" />
        <path d={path} stroke="url(#hg-line)" strokeWidth="2.5" />
        <path d={path} stroke="rgba(94,234,212,0.35)" strokeWidth="8" strokeLinecap="round" className="hg-dash" />
        {[0, 1, 2].map((i) => (
          <circle key={i} r="5" fill="#5eead4"><animateMotion dur="9s" repeatCount="indefinite" begin={`${i * 3}s`} path={path} /></circle>
        ))}
        {STAGES.map((s, i) => {
          const y = YS[i];
          const up = y < Y;
          const labelY = up ? y - 48 : y + 54;
          return (
            <g key={s.label} className="hg-node" style={{ animationDelay: `${i * 0.12}s` }}>
              <circle cx={s.x} cy={y} r="28" fill="#142441" stroke="rgba(94,234,212,0.65)" strokeWidth="2" />
              <circle cx={s.x} cy={y} r="36" stroke="rgba(94,234,212,0.2)" className="hg-ring" style={{ animationDelay: `${i * 0.5}s` }} />
              <text x={s.x} y={y + 5} textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontSize="13" fontWeight="700" fill="#5eead4">0{i + 1}</text>
              <text x={s.x} y={labelY} textAnchor="middle" fontFamily="Plus Jakarta Sans, sans-serif" fontWeight="700" fontSize="16" fill="#ffffff">{s.label}</text>
              {s.tags.map((t, j) => {
                const w = t.length * 7.4 + 22;
                const ty = up ? labelY - 44 - j * 28 : labelY + 12 + j * 28;
                return (
                  <g key={t} className="hg-float" style={{ animationDelay: `${(i + j) * 0.6}s` }}>
                    <rect x={s.x - w / 2} y={ty} rx="11" width={w} height="22" fill="rgba(20,36,65,0.9)" stroke="rgba(255,255,255,0.16)" />
                    <text x={s.x} y={ty + 15} textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontSize="10" fill="#cbd5e1" letterSpacing="0.05em">{t.toUpperCase()}</text>
                  </g>
                );
              })}
            </g>
          );
        })}
        <text x="400" y="30" textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontSize="11" fill="#94a3b8" letterSpacing="0.22em">THE PRODUCT LIFECYCLE · ONE STRATEGIC PARTNER</text>
        <text x="400" y="548" textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontSize="10" fill="#64748b" letterSpacing="0.18em">TEN CAPABILITIES BEHIND EVERY STAGE</text>
      </svg>

      <ol className="relative space-y-4 md:hidden" data-testid="hero-graphic-mobile">
        <span className="absolute left-[19px] top-4 h-[calc(100%-2rem)] w-px bg-gradient-to-b from-teal-300 via-teal-300/50 to-transparent" />
        {STAGES.map((s, i) => (
          <li key={s.label} className="hg-node relative flex items-start gap-4 pl-0" style={{ animationDelay: `${i * 0.1}s` }}>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-teal-300/70 bg-[#142441] font-mono text-xs font-bold text-teal-300">0{i + 1}</span>
            <div>
              <div className="text-base font-bold text-white">{s.label}</div>
              <div className="mt-1.5 flex flex-wrap gap-1.5">{s.tags.map((t) => <span key={t} className="rounded-full border border-white/15 bg-white/5 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-slate-300">{t}</span>)}</div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
